import { render } from "./StatusUptimeBars.vue?vue&type=template&id=7f39f589&scoped=true"
import script from "./StatusUptimeBars.vue?vue&type=script&lang=js"
export * from "./StatusUptimeBars.vue?vue&type=script&lang=js"

import "./StatusUptimeBars.vue?vue&type=style&index=0&id=7f39f589&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f39f589"]])

export default __exports__